<template>
  <div id="content"
       class="container">
    <!-- 右侧排行榜 -->
    <!-- 留念、新闻 -->
    <div class="all-right-wrap"
         v-if="show">
      <div class="right-title">
        <h4>排行榜</h4>
      </div>
      <div class="right-cont">
        <ul>
          <li v-for="(data,index) in dataList"
              :key="data.id">
            <div style="float:left">
              <span v-if="index === 0"><img :src="imgUrl1" /></span>
              <span v-if="index === 1"><img :src="imgUrl2" /></span>
              <span v-if="index === 2"><img :src="imgUrl3" /></span>
              <span v-if="index >= 3">{{index+1}}.</span>
            </div>
            <div class="right-text">
              <h5 @click="handleDetail(data.id)">{{data.title}}</h5>
              <div>
                <div class="train-time">{{data.createTime}}</div>
                <div class="train-good">
                  <div class="train-comment">
                    <img style="float:left;"
                         title="评论"
                         src="@/assets/img/comment_03.png" />
                    <span style="float:left;margin-left:5px;width: 24px;">{{data.commentCount}}</span>
                  </div>
                  <div class="train-praise">
                    <img style="float:left;"
                         title="赞一下"
                         src="@/assets/img/zan_03.png" />
                    <span style="float:left;margin-left:5px;width: 30px;">{{data.praiseCount}}</span>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="all-right-wrap"
         v-if="!show">
      <!-- 右侧上传及推荐列表 -->
      <div class="doclist-lastarea-r">
        <div class="doclist-upload"
             @click="showUpload">
          上传文档
        </div>
        <!-- 热门下载排行列表 -->
        <div class="doclist-hotdownloads">
          <h3>热门下载排行</h3>
          <ul v-if="hotDownloads">
            <li v-for="(item,index) in hotDownloads"
                :key="index"
                @click="jumpDocDetail(item)">
              <img alt="热门下载"
                   v-if="index + 1 === 1"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAkCAYAAABxE+FXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjQxQzlEQkVBMTE5MTFFOTlBRUNCNUJBNkFCREQ1N0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjQxQzlEQkZBMTE5MTFFOTlBRUNCNUJBNkFCREQ1N0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCNDFDOURCQ0ExMTkxMUU5OUFFQ0I1QkE2QUJERDU3QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCNDFDOURCREExMTkxMUU5OUFFQ0I1QkE2QUJERDU3QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpwY+9gAAAHZSURBVHjaYpRNXfGfYQDA1ho3BiaGAQSjlo88y1nI0aQswcvgYSgD57/68J1h9fEHtLech4OFYW62LYOSOC9c7PLDd2RZTnKw9yaYo1hMl2Dn42RlqAszYPA0kqFfnIvxczCEWysyJDipMYjycdAvwbGzMjOc6PBlYGFmon9WY2RkwLD4zvNPGOr+0zqf//z9l6F7w2UGn7bd9Ivz20Cfrjx6j2EdMCu9+fyTgZWKUYDX8h+//jI4128fLdtHLR+1fNRy+rVkfv/9xyCXtnI02Eeo5ZzsLPRNcExMjOBmc7anJoOiGC/Dwv23GebsucXw9vMP2lnOysLEEGiuwJDlocGI3HoFOSLZWY1h2eF7/2fuusHw/P036lnOBQzaKFtlhjQ3dUYJAU6sajjYmBmSnFUZYx2UGdYef/B/2o7rDA9efSHfcgFudmCLVYUhyUmNUYCbjbjQAbZyImyUGMOArd3Npx//n7L9OsPNpx+Itxzku1RXdYZoO2VGLjITFBOw5elvJscIxAy7Lj77P3nbNYaL99/itlwRGI+Z7hoMwZYKjNRsp7npSzECMcPh6y/Bjjhx8xVC0rN55//NZx79//fvP8P//7THZ+68+R8/6dB/YP/uP0CAAQBiHNQeibKNaAAAAABJRU5ErkJggg==">
              <img alt="热门下载"
                   v-if="index + 1 === 2"
                   src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAkCAYAAABxE+FXAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Q0ZEOEEyN0ZBMTE5MTFFOUFGNzk5MTUxNkExN0FGODUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Q0ZEOEEyODBBMTE5MTFFOUFGNzk5MTUxNkExN0FGODUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDRkQ4QTI3REExMTkxMUU5QUY3OTkxNTE2QTE3QUY4NSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDRkQ4QTI3RUExMTkxMUU5QUY3OTkxNTE2QTE3QUY4NSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PtVoD1IAAALqSURBVHjaYpRNXfGfYQDA1ho3BiaGAQSjlo88y1lIUWyqIsKQ4KTKYKwkwiDEw8bAxsLM8PnHb4YX778xHLv5imHilmsM7778pL7lMXbKDI0RRgysLKiBxc/FBsbq0gIMbvrSDGnTjzJcfvSeesHuYSjN0BZjgmExOpAW5mZYUezIwMrMRD3LExxVUfjvgUGbMu0Ig0HRBoaejZdR5Hg5WRks1UWpYzkLMyODkZIwitiC/bcZdl14Co7fSVuvMTx79w1F3lpDnDpx/ufvfwbj0k3gBCbEw8EgzMvOcPUxIk4FgeKifBwoeohNdEQluM/ff4Pxw9dfUcQZGRkYmtES4b9//8GhQvWshh63E5MtGFz0pFDEFx+8w3D/1RfaWa4kzsswL8cWTCODPZeeMTSsPE+bQgYE7LUlGKamWjLwAfM2Mpi16wZD29pLDP/+/6eN5VG2Sgyt0cYMzEyIOP7w9SdDxeIzDNvOPaFd8epuACxook0YmJgY4WJXgCVZ8tTDDM/ff6dd2a4gxsMwOcUCxeL/wOC99uQDQ7qbBob6W88+Miw7fI86lhf56jBwsLGgZTNGhjArRazq911+RpTlBEs4PmCW8jOVG5j6HFSNIgc3XevzvZefM8ilrRxtRo1aPsIt52RnoW1Ww3AtMM97GMowZHtqMiiK8TIsBDap5uy5xfD28w/aWQ5qrQSaKzBkeWgwItfjIEckO6uBitP/M4HV6vP336hnORcwaKNslRnS3NQZJQQ4sarhYGNmSHJWZYx1UGZYe/zB/2k7rjM8IKI1g9NyAW52YO9EhSHJSY1RgJuNuNABttcjbJQYw6wVGTaffvx/yvbrDDeffiDecpDvUl3VGaLtlBm5yExQTMAaz99MjhGIGXZdfPZ/8rZrDBfvv8VtuSIwHjPdNRiCLRUYie1xEAPc9KUYgZjh8PWXYEecAPbp4MCzeef/zWce/Qc1eUENBFrjM3fe/I+fdOj/5Yfv/gMEGAD7oi3xLC3n0AAAAABJRU5ErkJggg==">
              <img alt="热门下载"
                   v-if="index + 1 === 3"
                   src="data:image/png;base64,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">
              <p><span>{{index + 1}}.</span>{{item.fileTitle}}</p>
            </li>
          </ul>
        </div>
        <!-- 热门推荐列表 -->
        <div class="doclist-hotcommend">
          <h3>热门推荐</h3>
          <ul v-if="hotCommend">
            <li v-for="(item, index) in hotCommend"
                :key="index"
                @click="jumpDocDetail(item)">
              <div></div>
              <p>{{item.fileTitle}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 右侧底部图片 -->
    <!-- <div class="right-img-wrap">
      <img :src="imgUrl" />
    </div> -->
    <el-dialog title="上传资料"
               :visible.sync="isUploadShow"
               width="530px"
               class="doc-upload-area"
               :close-on-click-modal='false'
               :before-close="cancelUpload">
      <div>
        <h4 style="text-indent: 20px;">标题：</h4>
        <input type="text"
               v-model="uploadFileTitle"
               placeholder="请输入文档标题（限200字）...">
        <h4 style="text-indent: 20px;">下载所需积分：</h4>
        <input type="text"
               v-model="uploadFileScore"
               placeholder="请输入下载所需积分（0-5）" />
        <h4 style="margin-top: 20px; text-indent: 20px;">描述：</h4>
        <textarea v-model="uploadFileDescribe"
                  placeholder="请输入文档描述（限1000字）..."></textarea>
      </div>
      <div class="doc-upload-typechoose">
        <div v-if="uploadFileTypeChooseOne"
             class="doc-upload-kindonechoose"
             style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px;">
          <h4 style="padding-left: 20px">分类</h4>
          <ul>
            <li @click="handleUploadFileTypeOneChoose(index, item)"
                :class="activeUploadFileTypeOneIndex === index?'uploadFileTypeOneActive':''"
                v-for="(item, index) in uploadFileTypeChooseOne"
                :key="index">
              {{item.fileTypeName}}
            </li>
          </ul>
        </div>
        <div v-if="uploadFileTypeChooseTwo"
             class="doc-upload-kindtwochoose"
             style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px;">
          <ul>
            <li @click="handleUploadFileTypeTwoChoose(index, item)"
                :class="activeUploadFileTypeTwoIndex === index?'uploadFileTypeTwoActive':''"
                v-for="(item, index) in uploadFileTypeChooseTwo"
                :key="index">
              {{item.fileTypeName}}
            </li>
          </ul>
        </div>
        <div v-if="uploadFileTypeChooseThree"
             class="doc-upload-kindtwochoose"
             style="border-bottom: 1px solid #eeeeee; padding-bottom: 30px;">
          <ul>
            <li @click="handleUploadFileTypeThreeChoose(index, item)"
                :class="activeUploadFileTypeThreeIndex === index?'uploadFileTypeThreeActive':''"
                v-for="(item, index) in uploadFileTypeChooseThree"
                :key="index">
              {{item.fileTypeName}}
            </li>
          </ul>
        </div>
      </div>
      <div style="padding-left: 20px"
           slot="tip"
           class="el-upload__tip">只能上传doc/docx/pdf/ppt/pptx/xls/xlsx文件，且不超过100Mb</div>
      <el-upload class="upload-demo"
                 :before-remove="removeFile"
                 :on-success="successFile"
                 :on-error="errorFile"
                 :before-upload="beforeUpload"
                 :file-list="fileList"
                 ref="upLoadFile"
                 :limit="1"
                 :on-exceed="handleExceed"
                 :headers="headerMsg"
                 accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx,.pdf"
                 :action="uploadURL">
        <div slot="trigger"
             class="uploadPickUp">
          <i class="el-icon-upload2"></i> 选取文件
        </div>
        <p>文件大小不能大于100MB</p>
        <p>支持拓展名：.pdf .doc .docx .xls .xlsx .ppt .pptx</p>
        <!-- <p>文件名只支持汉字、英文字母以及数字</p> -->
        <el-button style="
            width: 265.5px;
            margin-top:50px;
            margin-left: 235px;
            border-radius: 0;
            height: 50px;
            text-aling: center;
            background: #1D65A8;
            color: white;
            border: 0;
            display: none;
          "
                   size="small"
                   type="success"
                   @click="submitUpload">确定</el-button>
      </el-upload>
      <div style="
          display:flex;
          margin-top: 40px;
          width: 530px;
          margin-left: -20px;
          margin-bottom: -30px;
          ">
        <div style=" flex: 1"
             class="upload-cancel"
             @click="cancelUpload">
          取消上传
        </div>
        <div style="
            width: 265.5px;
            border-radius: 0;
            height: 50px;
            text-aling: center;
            background: #1D65A8;
            color: white;
            text-align: center;
            line-height: 52px;
            flex: 1;
            user-select: none;
            cursor: pointer;
            font-size: 16px;
            font-weight: normal;
          "
             @click="submitUpload">
          确定上传
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getAccessToken } from '@/utils/userInfo'
import { track } from '@/utils/knowledgeEventTracking'
export default {
  data () {
    return {
      show: true,
      dataList: [],
      imgUrl: require('@/assets/img/bitmap_en.png'),
      imgUrl1: require('@/assets/img/1_03.png'),
      imgUrl2: require('@/assets/img/2_03.png'),
      imgUrl3: require('@/assets/img/3_03.png'),
      myname: this.name,
      rankImg: '',
      uploadFile: null,
      headerMsg: {
        Authorization: 'Bearer ' + getAccessToken()
      },
      uploadURL: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/fileConvert',
      fileList: [],
      activeCategoryOne: null,
      activeCategoryTwo: null,
      activeCategoryThree: null,
      typeList: null,
      typeListOne: null,
      typeListTwo: null,
      typeListThree: null,
      typeListOneActiveIndex: null,
      typeListTwoActiveIndex: null,
      typeListThreeActiveIndex: null,
      typeListOneActiveId: null,
      typeListTwoActiveId: null,
      typeListThreeActiveId: null,
      orderTimeNow: null,
      orderHotNow: 1,
      fileTypeIdNow: null,
      // 文档排序类型,1表示按照热门文档,0表示按照上传时间
      docSortType: 1,
      subscribeOrNot: false,
      activeCategoryId: null,
      currentPage: 1,
      totalPage: 4,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      likeUrl: 'data:image/png;base64,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',
      notLikeUrl: 'data:image/png;base64,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',
      hotDownloads: null,
      hotCommend: null,
      doclist: null,
      fileTypeId: null,
      activeCategoryOneIndex: null,
      activeCategoryTwoIndex: null,
      uploadFileTitle: '',
      uploadFileScore: '',
      uploadFileDescribe: '',
      activeUploadFileTypeOneIndex: null,
      activeUploadFileTypeTwoIndex: null,
      activeUploadFileTypeThreeIndex: null,
      activeUploadFileTypeTwoId: null,
      activeUploadFileTypeThreeId: null,
      uploadFileTypeChooseOne: null,
      uploadFileTypeChooseTwo: null,
      uploadFileTypeChooseThree: null,
      uploadData: null,
      isUploadShow: false,
      isSubscribeMaskShow: false,
      listSearch: '',
      activeSearch: '',
      // 订阅相关数据
      subscribeType: null,
      canSubscribeShow: null
    }
  },
  props: ['name'],
  mounted () {
    if (this.myname === 0) {
      this.getDataList()
    } else if (this.myname === 1) {
      this.getMerDataList()
    } else {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/variableFileLevel`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.typeList = data.data
            this.typeListOne = data.data
            if (this.typeListOne && this.menuType) {
              let index = this.typeListOne.findIndex(item => {
                return item.id === this.menuType
              })
              if (index > -1) {
                this.changeTypeListOne(index, this.typeListOne[index])
              }
            }
            this.uploadFileTypeChooseOne = data.data
          }
        })
        .catch(() => {
        })
    }
  },
  methods: {
    download (item) {
      if (this.$store.state.user.id) {
        this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/fileupload/alioss/isObjectExist/${item.ossId}`)
          .then(({ data }) => {
            if (data.code === 0) {
              track.clickDocDownload(item.fileTitle)
              this.downloadFile(item)
            }
          })
          .catch(() => {
            this.$message.warning('该文件不存在')
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    downloadFile (item) {
      this.$confirm(
        `下载${item.fileTitle}需要 ${item.score}积分?`,
        '提示',
        {
          confirmButtonText: '确定下载',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          return this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/userFileAddMinsPoint/${item.id}`)
        })
        .then(() => {
          let a = document.createElement('a')
          a.href = `${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/aliOssDownLoad/${item.id}/${this.$store.state.user.id}`
          a.click()
        })
        .catch(err => {
          if (err !== 'cancel') {
            this.$message.warning('积分不足')
          }
        })
    },
    handleUploadFileTypeOneChoose (index, item) {
      if (item.children === null) {
        this.$message.success('此分类仍在建设中，请选择其他分类')
        this.uploadFileTypeChooseTwo = null
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = null
        this.activeUploadFileTypeTwoId = null
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
      } else {
        this.uploadFileTypeChooseTwo = null
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = null
        this.activeUploadFileTypeTwoId = null
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.activeUploadFileTypeOneIndex = index
        this.uploadFileTypeChooseTwo = item.children
      }
    },
    handleUploadFileTypeTwoChoose (index, item) {
      if (item.children === null) {
        this.$message.error('此分类仍在建设中，请选择其他分类')
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.uploadFileTypeChooseThree = null
      } else {
        this.uploadFileTypeChooseThree = null
        this.activeUploadFileTypeTwoIndex = index
        this.activeUploadFileTypeTwoId = item.id
        this.activeUploadFileTypeThreeIndex = null
        this.activeUploadFileTypeThreeId = null
        this.uploadFileTypeChooseThree = item.children
      }
    },
    handleUploadFileTypeThreeChoose (index, item) {
      this.activeUploadFileTypeThreeIndex = index
      this.activeUploadFileTypeThreeId = item.id
    },
    handleSuccess (data) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/save`, {
        fileTitle: this.uploadFileTitle,
        score: this.uploadFileScore,
        discribe: this.uploadFileDescribe,
        fileTypeId: this.activeUploadFileTypeThreeId,
        ossId: this.fileList[0].ossId,
        downloaded: true
      })
        .then(({ data: item }) => {
          if (item.code === 0) {
            track.clickUploadFile(this.uploadFileTitle)
            this.$message.success('上传成功，请等待审核')
            this.isUploadShow = false
            this.getFileList()
          } else {
          }
        })
        .catch(() => {
          this.$message.error('服务器记录文档失败，请检查与服务器的连接，稍后再试')
        })
    },
    submitUpload (item) {
      if (this.uploadFileTitle === '' || this.uploadFileDescribe === '') {
        this.$message.error('必须填写文档标题以及文档描述才能上传文档')
      } else if (this.uploadFileTitle.length > 200) {
        this.$message.error('文档标题不能超过200字')
      } else if (!/^[0-5]{1}$/.test(this.uploadFileScore)) {
        this.$message.error('文档下载积分请输入0-5')
      } else if (this.uploadFileDescribe.length > 1000) {
        this.$message.error('文档描述不能超过1000字')
      } else if (this.activeUploadFileTypeThreeId === null) {
        this.$message.error('必须选择三级分类才能上传文档')
      } else if (this.fileList.length === 0) {
        this.$message.error('必须选择一个文档才能上传文档')
      } else {
        this.handleSuccess()
      }
    },
    // 上传失败
    errorFile () {
      this.subLoading = false
    },
    // 上传成功
    successFile (response, file, fileList) {
      if (response.code === 0) {
        this.fileList.push({
          uid: file.uid,
          ossId: response.data.aliOssId,
          ossName: file.name,
          name: file.name
        })
        this.subLoading = false
      } else {
        this.$refs.upLoadFile.abort(file) // upload: el-upload的ref值；file:File类型，file文件本身
        fileList.splice(fileList.indexOf(file), 1) // fileList: 文件列表，钩子函数中的fileList
        this.removeFile(file, fileList)
        this.$message.error(response.msg || '上传失败')
        this.subLoading = false
      }
    },
    // 上传
    beforeUpload (file) {
      if (this.subLoading) {
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB!')
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
        let type = file.name.split('.')[1]
        let fileAcceptList = ['doc', 'docx', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx']
        if (!fileAcceptList.includes(type)) {
          this.$message.error('请上传正确的文件类型')
          return false
        }
      } else {
        this.$message.warning('文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号')
        return false
      }
    },
    // 删除文件
    removeFile (file) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId) {
        let index = this.fileList.findIndex(item => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http.post(`${window.SITE_CONFIG['apiURL']}/help/fileupload/sys/deleteBatchAliOss`, [this.fileList[index].ossId])
            .then(item => {
              this.fileList.splice(index, 1)
            })
            .catch(() => {
            })
        }
      }
    },
    cancelUpload () {
      this.isUploadShow = false
      if (this.fileList.length) {
        for (let index = 0; index < this.fileList.length; index++) {
          this.removeFile(this.fileList[index])
        }
      }
    },
    handleExceed () {
      this.$message.error('上传文件数量不能超过一个')
    },
    jumpDocDetail (item) {
      track.clickDocDetail(item.fileTitle)
      this.$router.push({
        path: '/trainbookDocDetail',
        query: {
          fileId: item.id
        }
      })
    },
    showUpload () {
      if (this.$store.state.user.id) {
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/searchFileType`, {
          userId: this.$store.state.user.id || null
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.isUploadShow = true
              this.uploadFileTitle = ''
              this.uploadFileDescribe = ''
              this.uploadFileScore = 0
              this.activeUploadFileTypeOneIndex = null
              this.uploadFileTypeChooseTwo = null
              this.uploadFileTypeChooseThree = null
              this.activeUploadFileTypeTwoIndex = null
              this.activeUploadFileTypeTwoId = null
              this.activeUploadFileTypeThreeIndex = null
              this.activeUploadFileTypeThreeId = null
              this.$refs.upload.clearFiles()
            } else {
              this.$router.push({ name: 'login' })
            }
          })
          .catch(() => {
          })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    // 新闻排行榜
    getDataList () {
      this.show = true
      this.$http.get(`/front/train/trainNews/searchNewsRanking`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data
            this.rankImg = res.data[0].imageUrl
          }
        })
    },
    // 留念排行榜
    getMerDataList () {
      this.show = true
      this.$http.get(`/front/train/trainNews/searchMemorialRanking`).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataList = res.data
          this.rankImg = res.data[0].imageUrl
        }
      })
    },
    // 工业头条排行榜
    getTopList () {
      this.show = false
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/hotDownload`)
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            this.hotDownloads = res.data.data.slice(0, 10)
          }
        }).catch(() => { })
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfile/hotRecommend`)
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            this.hotCommend = res.data.data.slice(0, 10)
          }
        })
        .catch(() => {
        })
    },
    // 跳转详情
    handleDetail (id) {
      this.$router.push(
        { name: 'trainTrendInfo', query: { id: id } }
      )
    }
  }
}
</script>
<style scoped>
ul {
  list-style: none;
}
h5 {
  margin-top: 0px !important;
}
/* 右侧排行榜 */
.all-right-wrap {
  width: 300px;
  float: right;
  height: auto;
  background: #fff;
  margin-top: 10px;
}
.right-title {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #ccc;
  line-height: 40px;
  padding-left: 20px;
}
.right-title h4 {
  font-size: 16px;
  color: #333;
}
.right-cont {
  width: 100%;
  padding: 0 10px;
  height: auto;
}
.right-cont ul li {
  width: 100%;
  height: 70px;
  padding: 10px 0;
  border-bottom: 1px solid #ccc;
}
.right-cont ul li img {
  height: 20px;
}
.right-number {
  width: 20px;
  height: 20px;
  float: left;
  padding-left: 5px;
}
.right-number img {
  width: 20px;
  height: 20px;
}
.right-text {
  float: left;
  width: 250px;
  height: 50px;
  margin-left: 10px;
}
.right-text h5 {
  width: 230px;
  color: #333;
  font-weight: 700;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  margin-bottom: 5px;
  cursor: pointer;
}
.right-text h5:hover {
  color: #1d65a8;
}
/* 右侧底部图片 */
.right-img-wrap {
  float: right;
  width: 290px;
  height: 200px;
  margin-top: 20px;
}
.right-img-wrap img {
  width: 290px;
  height: 200px;
}
.train-time {
  float: left;
  width: 142px;
  height: 30px;
  line-height: 40px;
  color: #999;
}
.train-good {
  float: right;
  width: 98px;
  height: 30px;
  padding-top: 10px;
}
.train-comment {
  width: 44px;
  height: 30px;
  float: left;
}
.train-comment img {
  width: 15px;
  height: 15px;
}
.train-praise {
  float: left;
  width: 50px;
  height: 30px;
  margin-left: 2px;
}
.train-praise img {
  width: 15px;
  height: 15px;
}
/* 热门下载排行样式 */
.doclist-hotdownloads {
  margin: 20px 0 30px 0;
  padding-left: 26px;
  padding-right: 20px;
  padding-bottom: 32px;
  background: #ffffff;
}
.doclist-hotdownloads h3 {
  width: 280px;
  margin-left: -26px;
  padding-left: 26px;
  height: 43px;
  line-height: 43px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  border-bottom: 1px solid #eeeeee;
}
.doclist-hotdownloads ul li {
  position: relative;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  user-select: none;
  cursor: pointer;
}
.doclist-hotdownloads ul li img {
  position: absolute;
  width: 15.5px;
  height: 18px;
  left: 0;
  top: 8px;
}
.doclist-hotdownloads ul li p {
  width: 233px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.doclist-hotdownloads ul li p span {
  display: inline-block;
  width: 23px;
}
/* 热门推荐样式 */
.doclist-hotcommend {
  margin: 20px 0 30px 0;
  padding-left: 26px;
  padding-right: 20px;
  padding-bottom: 32px;
  background: #ffffff;
}
.doclist-hotcommend h3 {
  margin-top: 0;
  width: 280px;
  margin-left: -26px;
  padding-left: 26px;
  height: 43px;
  line-height: 43px;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  border-bottom: 1px solid #eeeeee;
}
.doclist-hotcommend ul li {
  display: flex;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #333333;
  user-select: none;
  cursor: pointer;
}
.doclist-hotcommend ul li div {
  width: 6px;
  height: 6px;
  margin: auto 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #1d65a8;
}
.doclist-hotcommend ul li p {
  margin: 0;
  width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.doclist-lastarea-r {
  flex: 1;
}
.doclist-upload {
  height: 78px;
  background: url(data:image/png;base64,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)
    no-repeat 69px 28px;
  background-size: 28px 25px;
  background-color: #1d65a8;
  text-indent: 112px;
  line-height: 78px;
  color: #ffffff;
  font-size: 24px;
  cursor: pointer;
  user-select: none;
}
/* 上传文件蒙版样式 */
.upload-cancel {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  box-sizing: border-box;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  font-size: 14px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.upload-cancel:hover {
  opacity: 0.8;
}
.doc-upload {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  padding-top: 150px;
  top: 0;
  left: 0;
  z-index: 999;
}
.uploadPickUp {
  width: 106px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #595959;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.uploadPickUp .el-icon-upload2 {
  color: #595959;
  font-size: 14px;
}
.doc-upload-area h3 {
  height: 30px;
  font-size: 20px;
  margin: 10px 0;
}
.doc-upload-area input {
  width: 92%;
  margin: 0 auto;
  line-height: 24px;
  font-size: 18px;
  display: block;
  border: 1px solid #cccccc;
  padding: 4px 10px;
  border-radius: 6px;
}
.doc-upload-area input:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-typechoose ul {
  padding-left: 80px;
}
.doc-upload-kindonechoose ul {
  margin-top: -30px;
}
.doc-upload-area textarea {
  width: 92%;
  height: 80px;
  line-height: 20px;
  resize: none;
  font-size: 16px;
  margin: 0 auto 20px auto;
  display: block;
  padding: 4px 10px;
  border: 1px solid #cccccc;
  border-radius: 6px;
}
.doc-upload-area textarea:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-area .el-upload__tip {
  word-break: break-all;
}
.doc-upload-fileorvedio {
  display: flex;
  margin-bottom: 20px;
}
.doc-upload-fileorvedio div {
  padding: 2px 10px;
  text-align: center;
  margin: 0 10px;
  border: 1px solid #1d65a8;
  user-select: none;
  cursor: pointer;
}
.uploadFileTypeOneActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindonechoose {
  margin-bottom: 20px;
}
.doc-upload-kindonechoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindonechoose ul li {
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
.uploadFileTypeTwoActive {
  background: #1d65a8;
  color: #ffffff;
}
.uploadFileTypeThreeActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindtwochoose {
  margin-bottom: 20px;
}
.doc-upload-kindtwochoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindtwochoose ul li {
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
</style>
